import { useTranslation } from "react-i18next";
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { toast } from 'sonner';
import DocumentDetailPanel from './DocumentDetailPanel';

export default function EntityDocumentsTab({ user, entityType, entityId }) {
  const { t } = useTranslation();
  const [docs, setDocs] = useState([]);
  const [includeSuperseded, setIncludeSuperseded] = useState(false);
  const [selectedDocId, setSelectedDocId] = useState(null);

  useEffect(() => { load(); }, [entityType, entityId, includeSuperseded]);

  async function load() {
    try {
      const params = new URLSearchParams();
      params.append('related_entity_id', entityId);
      if (!includeSuperseded) params.append('include_superseded', 'false');
      const res = await axios.get(`/cycle3/documents?${params.toString()}`);
      const list = (res.data || []).filter(d => d.entity_type === entityType);
      setDocs(list);
    } catch (e) {
      toast.error(t("documents.failedToLoad"));
    }
  }

  return (
    <div className="flex w-full">
      <div className="flex-1 pr-4">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2 text-sm">
            <Label>{t("documents.showSuperseded")}</Label>
            <Switch checked={includeSuperseded} onCheckedChange={setIncludeSuperseded} />
          </div>
        </div>
        <div className="grid grid-cols-1 gap-2">
          {docs.map(d => (
            <Card key={d.id} onClick={() => setSelectedDocId(d.id)} className="border-white/60 cursor-pointer hover:bg-slate-50:bg-zinc-800">
              <CardContent className="p-3 flex items-center justify-between">
                <div>
                  <div className="font-medium">{d.original_filename} <span className="text-xs text-[#94A3B8]">v{d.version || 1}</span></div>
                  <div className="text-xs text-[#475569]">{d.doc_type} • {new Date(d.uploaded_at).toLocaleString()}</div>
                </div>
                <div className="text-xs text-[#94A3B8]">{d.superseded ? t("documents.superseded") : t("documents.current")}</div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
      {selectedDocId && (
        <DocumentDetailPanel docId={selectedDocId} user={user} onClose={() => setSelectedDocId(null)} onUpdated={load} />
      )}
    </div>
  );
}
